import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Popover, Stack, Svg, Text } from '@hopskipdrive/react-components';
import { ArrowDropDown } from '@mui/icons-material';
import { capitalize } from 'lodash';

import { priorityLevelMapper } from '../FilterPanel.helper';
import { CloseButton, FilterButton, FilterTypeContainer } from '../FilterPanel.styles';

import { PriorityChip } from './PriorityFilter.styles';

const priorityOptions = [0, 1, 2, 3];

export const PriorityFilter = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const params = Object.fromEntries(searchParams.entries());
  const hasPriority = params.priority && priorityOptions.some((option) => option === Number(params.priority));

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePriorityChange = (priority) => {
    const newParams = new URLSearchParams(searchParams);

    if (searchParams.get('page')) {
      newParams.set('page', '1');
    }

    newParams.set('priority', priority);
    setSearchParams(newParams);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'status-filter-popover' : undefined;

  return (
    <>
      <FilterButton variant="text" open={open} active={Boolean(hasPriority)} onClick={handleOpen}>
        Priority
        <ArrowDropDown />
      </FilterButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{ '.MuiBackdrop-root': { backgroundColor: 'transparent' } }}
      >
        <FilterTypeContainer>
          <Box className="filter-header">
            <Text variant="body2">Filter by Priority</Text>
            <CloseButton onClick={handleClose}>
              <Svg icon="cross" />
            </CloseButton>
          </Box>
          {priorityOptions.length && (
            <Stack spacing={2}>
              {priorityOptions.map((option, index) => (
                <PriorityChip
                  key={index}
                  className={`${priorityLevelMapper[option]}`}
                  label={`P${option} ${capitalize(priorityLevelMapper[option])}`}
                  variant="outlined"
                  onClick={() => {
                    handlePriorityChange(option);
                    handleClose();
                  }}
                />
              ))}
            </Stack>
          )}
        </FilterTypeContainer>
      </Popover>
    </>
  );
};
